module.exports = __webpack_public_path__ + "static/media/gpxcarbo.3d9ddf8f.png";